import {   
    REQUEST_COMPANY_LOANS,
    RECEIVE_COMPANY_LOANS_SUCCESS,
    RECEIVE_COMPANY_LOANS_ERROR,
    REQUEST_COMPANY_APPLICATIONS,
    RECEIVE_COMPANY_APPLICATIONS_SUCCESS,
    RECEIVE_COMPANY_APPLICATIONS_ERROR,
    REQUEST_COMPANY_USERS,
    RECEIVE_COMPANY_USERS_SUCCESS,
    RECEIVE_COMPANY_USERS_ERROR,
    RECEIVE_COMPANY_SAVE_SUCCESS
   
            }  from '../actions/company'
            import {   

            REQUEST_COMPANY_INVOICES,
            RECEIVE_COMPANY_INVOICES_SUCCESS,
            RECEIVE_COMPANY_INVOICES_ERROR,
            RECEIVE_INVOICE_CREATE_SUCCESS,
            RECEIVE_INVOICE_SAVE_SUCCESS
        }  from '../actions/invoice'
        

const DEFAULT_CURRENTCOMPANY =   {
                isUsersFetching: false,
                isApplicationsFetching: false,
                isLoansFetching: false,
                isInvoicesFetching: false,
                loans: [],
                applications: [],
                users: [],
                invoices: []
                };


export function currentCompany(state = DEFAULT_CURRENTCOMPANY, action) {
    
    switch (action.type) {
        case REQUEST_COMPANY_LOANS: {
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...state.invoices],
                isLoansFetching: true
            };
            return newstate;
         }

         case RECEIVE_INVOICE_SAVE_SUCCESS: {

            let ind = state.invoices.findIndex(x => x.id === action.item.id);
            if (ind < 0) 
                return state;
            
            let newState = {...state,
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...state.invoices]}
        
            newState.invoices[ind] =  {
                        ...action.item, 
                        isFetching: false,
                        isSaving: false};                    
            return newState;

         }

        case RECEIVE_COMPANY_LOANS_SUCCESS: {                        
            var newstate = {
                ...state, 
                loans: [...action.items],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...state.invoices],
                isLoansFetching: false
            }                 
            return newstate;            
        }                      
        
        case RECEIVE_INVOICE_CREATE_SUCCESS: {                        
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [action.item, ...state.invoices],
                isLoansFetching: false,
                isInvoicesFetching: false
            }                 
            return newstate;            
        }              


        case REQUEST_COMPANY_INVOICES: {
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...state.invoices],
                isInvoicesFetching: true
            };
            return newstate;
         }

        case RECEIVE_COMPANY_INVOICES_SUCCESS: {                        
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...action.items],
                isInvoicesFetching: false
            }                 
            return newstate;            
        }  

        case REQUEST_COMPANY_USERS: {
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...state.invoices],
                isUsersFetching: true
            };
            return newstate;
         }

         case RECEIVE_COMPANY_SAVE_SUCCESS: {
            let newState = 
                {...state,
                    ...action.company, 
                    loans: [...state.loans],             
                    applications: [...state.applications],
                    users: [...state.users],
                    invoices: [...state.invoices], 
                    isFetching: false}    
            return newState;
        }

        case RECEIVE_COMPANY_USERS_SUCCESS: {                        
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...action.items],
                invoices: [...state.invoices],
                isUsersFetching: false
            }                 
            return newstate;            
        }  

        case REQUEST_COMPANY_APPLICATIONS: {
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...state.applications],
                users: [...state.users],
                invoices: [...state.invoices],
                isApplicationsFetching: true
            };
            return newstate;
         }

        case RECEIVE_COMPANY_APPLICATIONS_SUCCESS: {                        
            var newstate = {
                ...state, 
                loans: [...state.loans],             
                applications: [...action.items],
                users: [...state.users],
                invoices: [...state.invoices],
                isApplicationsFetching: false
            }                 
            return newstate;            
        }  

        default: {
            return state;
        }
    }
}
